import React, {ChangeEvent, useRef, useState} from "react";
import {indexWrapCss} from "./css/Goods.style";
import Header from "../../common/layouts/header/Header";
import Footer from "../../common/layouts/footer/Footer";
import Modal from "react-modal";
import ImageCrop from "../author/ImageCrop";
import {addPostCard} from "../../api/index";
import Alert from "../../common/layouts/modal/Alert";
import PostCardList from "./PostCardList";
import {useNavigate} from "react-router-dom";
import AddGoodsMobile from "./mobile/AddGoodsMobile";

interface AddGoodsProps {
    postCardList: any;
    isMobile: boolean;
    onDelete: (id: number) => void;
    onUpdate : (id : number , msg : string) => void;
    currentPage : number,
    totalPages: number,
    onPageChange: (newPage: number) => void;
}

const AddGoods = ({ postCardList, isMobile, onDelete, onUpdate , currentPage, totalPages, onPageChange }: AddGoodsProps) => {


    const navigate = useNavigate();

    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };
    const [postCardPreview, setPostCardPreview] = useState<string | undefined>(undefined);
    const [postCard, setPostCard] = useState<string | undefined>(undefined);
    const postCardRef = useRef<HTMLInputElement | null>(null);
    const [errors, setErrors] = useState<{ img?: string }>({});
    const [showImageCrop, setShowImageCrop] = useState(false);
    const [postCardText, setPostCardText] = useState<string>("");
    const [showAlert, setShowAlert] = useState(false);

    const [image, setImage] = useState<string | null>(null);

    const closeModal = () => {
        setShowImageCrop(false);
    };

    const handleCrop = (cropData: string) => {

        setPostCardPreview(cropData);

        closeModal();
    };

    const blobToFile = (blob: Blob, fileName: string): File => {
        return new File([blob], fileName, { type: blob.type });
    };

    const base64ToBlob = (base64: string, contentType: string): Blob => {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    };

    const formData = new FormData();
    formData.append('postCardContent', postCardText);

    if (postCardPreview) {
        const blob = base64ToBlob(postCardPreview, 'image/png');
        const file = blobToFile(blob, 'postCardPhoto.png');
        formData.append('postCardPhoto', file);
    }



    const handleAddPostcard = async () => {
        if (!postCardPreview) {
            setErrors({ img: '*이미지를 업로드 해주세요.' });
            return;
        }

        try {
            await addPostCard(formData).then(r => {
                console.log("엽서 등록 성공!");

                setShowAlert(true);


                }
            );

        } catch (error) {
            console.error("엽서 등록 실패", error);
        }

    };


    const openModal = () => {
        setShowImageCrop(true);
    };


    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file ) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result as string);
            openModal();
            /*
            if (typeof reader.result === 'string') {
                const base64String = reader.result;

                const base64Data = base64String.split(',')[1];

                const blob = base64ToBlob(base64Data, file.type);

                const previewUrl = URL.createObjectURL(blob);

                setPostCard(base64String);
                setPostCardPreview(previewUrl);
            }*/
        };
        reader.readAsDataURL(file);

    };


    return isMobile ? (

        <AddGoodsMobile postCardList={postCardList}  onDelete={onDelete}  onUpdate={onUpdate} isMobile={true} currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}/>
        ) : (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag=""
            />

            {/* 히어로 섹션 */}
            <div style={{ background: 'linear-gradient(180deg, #e8f8f0 0%, #edf9f3 40%, #fafafa 100%)' }}
                 className="w-full pt-12 pb-14 px-4">
                <div className="max-w-[700px] mx-auto flex flex-col items-center text-center gap-3">

                    <h1 className="font-bold text-[#222] leading-tight text-[32px]">
                        🖼️  엽서 등록
                    </h1>

                </div>
            </div>

            {/* 메인 콘텐츠 */}
            <div className="flex justify-center py-12 px-4">
                <div className="w-full max-w-[900px] flex flex-col gap-10">

                    {/* 엽서 추가 카드 */}
                    <div className="bg-white rounded-3xl border border-[#edfcf5] shadow-[0_8px_30px_rgb(0,0,0,0.03)] p-10 hover:shadow-[0_8px_30px_rgba(25,207,122,0.06)] transition-all duration-300">
                        <h2 className="text-[#222] text-[22px] font-bold mb-6 flex items-center gap-2">
                            <span className="w-2.5 h-6 bg-[#19cf7a] rounded-full inline-block"></span>
                            새 엽서 추가
                        </h2>

                        <div className="flex flex-col md:flex-row gap-8 items-start">
                            {/* 이미지 업로드 */}
                            <div className="flex flex-col gap-4 items-center flex-shrink-0 mx-auto md:mx-0">
                                <div
                                    id="img-preview"
                                    className="w-[220px] h-[310px] rounded-2xl overflow-hidden border border-[#d2f3e2] bg-[#f5fdf9] flex items-center justify-center shadow-inner hover:scale-[1.02] hover:border-[#19cf7a] transition-all duration-300 cursor-pointer group"
                                    onClick={() => postCardRef.current?.click()}
                                >
                                    {postCardPreview ? (
                                        <img
                                            className="w-full h-full object-cover rounded-2xl"
                                            src={postCardPreview}
                                            alt="엽서 미리보기"
                                        />
                                    ) : (
                                        <div className="flex flex-col items-center gap-2 text-[#aaa] group-hover:text-[#19cf7a] transition-colors">
                                            <span className="text-[13px] font-medium font-namsan">엽서 이미지 선택</span>
                                            <span className="text-[10px] text-[#ccc]">클릭하여 등록</span>
                                        </div>
                                    )}
                                </div>

                                <button
                                    className="relative w-[220px] h-11 text-[14px] font-bold rounded-full bg-white text-[#19cf7a] border-2 border-[#19cf7a] flex items-center justify-center hover:bg-[#19cf7a] hover:text-white transition-all active:scale-95 duration-200"
                                    type="button"
                                >
                                    <input
                                        ref={postCardRef}
                                        className="absolute top-0 left-0 opacity-0 w-full h-full cursor-pointer"
                                        type="file"
                                        id="backgroundFileInput"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                    이미지 선택
                                </button>
                                <span className="text-[#aaa] text-[12px] font-medium font-namsan">*최대 1MB까지 업로드 가능</span>
                            </div>

                            <Modal
                                isOpen={showImageCrop}
                                shouldCloseOnOverlayClick={false}
                                onRequestClose={closeModal}
                                contentLabel="imageCrop Modal"
                                className="modal-login"
                                ariaHideApp={false}
                                overlayClassName="overlay">
                                {image && (
                                    <ImageCrop
                                        image={image}
                                        onClose={closeModal}
                                        onCrop={handleCrop}
                                    />
                                )}
                            </Modal>

                            {/* 텍스트 + 버튼 */}
                            <div className="flex flex-col gap-4 flex-1 w-full">
                                <div className="flex flex-col gap-1">
                                    <label className="text-[#333] text-[16px] font-bold">엽서 설명</label>
                                    <span className="text-[#aaa] text-[13px] font-medium font-namsan">엽서에 담긴 소중한 이야기를 들려주세요</span>
                                </div>
                                <div className="relative w-full">
                                    <textarea
                                        className="w-full h-[200px] border border-[#d2f3e2] bg-[#f9fdfa] p-5 rounded-2xl resize-none font-namsan text-[13px] text-center focus:outline-none focus:border-[#19cf7a] focus:ring-2 focus:ring-[#19cf7a]/10 transition-all placeholder:text-[#ccc] shadow-sm leading-relaxed"
                                        value={postCardText}
                                        maxLength={200}
                                        placeholder="엽서에 담긴 이야기를 독자들과 공유하세요. (최대 200자)"
                                        onChange={(e) => setPostCardText(e.target.value)}
                                    />
                                    <div className="absolute bottom-3 right-4 text-xs font-semibold text-[#aaa] font-namsan">
                                        {postCardText.length}/200
                                    </div>
                                </div>

                                {errors.img && (
                                    <p className="text-red-500 font-namsan font-semibold text-[14px]">
                                        {errors.img}
                                    </p>
                                )}

                                <button
                                    className="w-full h-[52px] rounded-full bg-[#19cf7a] text-white font-bold text-[16px] hover:bg-[#00b368] hover:scale-[1.01] active:scale-[0.99] shadow-[0px_8px_16px_rgba(25,207,122,0.15)] hover:shadow-[0px_8px_20px_rgba(25,207,122,0.25)] transition-all duration-200"
                                    onClick={handleAddPostcard}
                                    type="button"
                                >
                                    엽서 추가하기
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 등록된 엽서 목록 */}
                    <div className="bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-8">
                        <h2 className="text-[#222] text-[20px] font-bold mb-6">등록된 엽서 목록</h2>
                        <PostCardList postCardList={postCardList} onDelete={onDelete} onUpdate={onUpdate} currentPage={currentPage}
                                      totalPages={totalPages}
                                      onPageChange={onPageChange}/>
                    </div>

                </div>
            </div>


            {showAlert && (
                <Alert
                    title=""
                    message="엽서가 등록되었습니다."
                    onClose={() => {
                        setShowAlert(false)
                        navigate(0);
                    }
                    }
                />
            )}

            {/* 엽서 등록 contents 영역*/}



            <Footer/>
        </div>
        );


}

export default AddGoods;
